import React, { useState, useEffect } from "react";
import { ShieldAlert, LogOut } from "lucide-react";

export default function ImpersonationBanner() {
  const [impersonator, setImpersonator] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);

  const checkImpersonation = () => {
    try {
      const impRaw = localStorage.getItem("hm_impersonator");
      const userRaw = localStorage.getItem("hm_user");
      if (impRaw) {
        setImpersonator(JSON.parse(impRaw));
        setCurrentUser(userRaw ? JSON.parse(userRaw) : null);
      } else {
        setImpersonator(null);
        setCurrentUser(null);
      }
    } catch {
      setImpersonator(null);
      setCurrentUser(null);
    }
  };

  useEffect(() => {
    checkImpersonation();
    const handleStorage = () => checkImpersonation();
    window.addEventListener("storage", handleStorage);
    window.addEventListener("impersonationChanged", handleStorage);

    return () => {
      window.removeEventListener("storage", handleStorage);
      window.removeEventListener("impersonationChanged", handleStorage);
    };
  }, []);

  const handleExit = () => {
    try {
      const impRaw = localStorage.getItem("hm_impersonator");
      if (impRaw) {
        const data = JSON.parse(impRaw);
        if (data.adminToken) {
          localStorage.setItem("hm_auth_token", data.adminToken);
        }
        if (data.adminUser) {
          localStorage.setItem("hm_user", JSON.stringify(data.adminUser));
        }
        localStorage.setItem("hm_admin_auth", "true");
        localStorage.removeItem("hm_impersonator");
        window.dispatchEvent(new Event("impersonationChanged"));
        window.location.href = "/admin/users";
      }
    } catch (e) {
      console.error("Failed to exit impersonation mode", e);
      window.location.href = "/admin";
    }
  };

  if (!impersonator || !currentUser) {
    return null;
  }

  return (
    <div
      className="sticky top-0 z-[9999] bg-[#E76F51] text-white px-4 py-2 shadow-lg flex items-center justify-between flex-wrap gap-2 text-xs sm:text-sm font-medium border-b border-black/10"
      data-testid="impersonation-banner"
    >
      <div className="flex items-center gap-2">
        <span className="p-1 rounded-full bg-white/20">
          <ShieldAlert className="w-4 h-4 text-white" />
        </span>
        <span>
          <strong>Admin View:</strong> Logged in as{" "}
          <span className="underline font-bold">{currentUser.username}</span>{" "}
          ({currentUser.role}
          {currentUser.property_id ? ` • ${currentUser.property_id}` : ""})
        </span>
      </div>

      <button
        onClick={handleExit}
        className="flex items-center gap-1.5 px-3 py-1 rounded-md bg-white text-[#E76F51] hover:bg-orange-50 font-bold transition-all shadow-sm text-xs cursor-pointer active:scale-95"
        data-testid="exit-impersonation-btn"
      >
        <LogOut className="w-3.5 h-3.5" />
        <span>Exit & Return to Admin</span>
      </button>
    </div>
  );
}
